/**
 * Template Panel Component
 *
 * Main container that shows either the template library or the wizard,
 * depending on whether a template has been selected.
 */

import { useTemplateStore, useSelectedTemplate } from './templateStore';
import { TemplateLibrary } from './TemplateLibrary';
import { TemplateWizard } from './TemplateWizard';

/**
 * Template Panel - switches between library and wizard views
 */
export function TemplatePanel() {
  const selectedTemplate = useSelectedTemplate();

  return (
    <div className="h-full bg-background">
      {selectedTemplate ? <TemplateWizard /> : <TemplateLibrary />}
    </div>
  );
}

/**
 * Floating Template Button - triggers opening the template panel
 */
export function TemplateButton({ onClick }: { onClick?: () => void }) {
  const openPanel = useTemplateStore((s) => s.openPanel);

  const handleClick = () => {
    openPanel();
    onClick?.();
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors shadow-lg"
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 4.5v15m7.5-7.5h-15"
        />
      </svg>
      <span className="font-medium">Add System</span>
    </button>
  );
}

export default TemplatePanel;
